export default __webpack_public_path__ + "static/media/gameon.cfedc40a.jpg";